// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"footer__wrapper-3nbrv","block":"footer__block-2syT4","content":"footer__content-35ZaE blocks__content--MOaB","info":"footer__info-6Wggz","row":"footer__row-2L0qJ","column":"footer__column-1VJdq","link":"footer__link-1_Xww","copyRight":"footer__copyRight-3n63p","redirect":"footer__redirect-17Hld"};


//////////////////
// WEBPACK FOOTER
// ./components/layout/footer/footer.css
// module id = 838
// module chunks = 0